/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClickHandler.bind(this));
    }
    onClickHandler(event) {
      event.preventDefault();
      const index = this.dataset.index;
      const linkedIndices = this.findBundleChildren(index);

      if (linkedIndices.length > 0) {
        this.removeBundledItems([index, ...linkedIndices]);
      } else {
        const cartDrawer = this.closest('cart-drawer');
        if (cartDrawer) {
          cartDrawer.updateQuantity(index, '0');
        } else {
          document.dispatchEvent(new CustomEvent('cart:remove', { detail: { index } }));
        }
      }
    }
    findBundleChildren(parentIndex) {
      const parentEl =
        document.getElementById(`CartItem-${parentIndex}`) ||
        document.getElementById(`CartDrawerItem-${parentIndex}`);
      const bundleId = parentEl?.dataset.bundleId;
      if (!bundleId) return [];

      const children = [];
      document.querySelectorAll('[data-bundle-id][data-is-naamkaartje]').forEach(el => {
        if (el.dataset.bundleId === bundleId) {
          const match = el.id.match(/(\d+)$/);
          if (match) children.push(match[1]);
        }
      });
      return children;
    }
    async removeBundledItems(indices) {
      // Remove from highest to lowest index to prevent line number shifting
      const sorted = [...indices].sort((a, b) => parseInt(b) - parseInt(a));

      for (const idx of sorted) {
        await fetch(theme.routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: idx, quantity: 0 })
        });
      }

      // cart:refresh triggers both ThemeCart.refresh() and CartDrawer.refresh()
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }
  customElements.define('cart-remove', CartRemove);
}
